import { Button } from "@mui/material";
import { Link as RouterLink } from "react-router";
import useClientContext from "../../../../context/useClientContext";
import { pageRoutes } from "../../../../routes";
import { useObjectDefinitionContext } from "../ObjectDefinitionContext";

export const EditLayoutLink = ({ configurationId }: { configurationId: string }) => {
  const { clientCode } = useClientContext();
  const { hasEditPermissions, objectDefinition } = useObjectDefinitionContext();

  if (!hasEditPermissions) {
    return null;
  }

  const editLayoutPath = `/${clientCode}/${pageRoutes.settings}/${pageRoutes.dataModel}/${pageRoutes.orgObjects}/${objectDefinition.objectType}/${pageRoutes.layout}/${configurationId}`;

  return (
    <Button component={RouterLink} to={editLayoutPath} color="secondary">
      Edit Layout
    </Button>
  );
};
